import styled from 'styled-components';

import {Column, Row} from '../../../../../stories/components/hotels/common/Layouts/Layouts';

export const DetailRoomInfoOuterWrap = styled.div(
  props => `
    width:100%;
    max-width: 120rem;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.nospacing};
  `
);

export const RoomAmenitesSortWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    padding-bottom: ${props.theme.spacing.large.l20};
  `
);

export const RoomAmenitiesSortList = styled.ul(
  props => `
    width: 100%;
    display: flex;
    align-items: center;
    list-style-stype: none;
    
    li{
      display: flex;
      justify-content: flex-start;
      box-shadow: 0 0 4px 0 ${props.theme.colors.black.light2};
      border-radius: ${props.theme.misc.borderRadius.base};
      background-color: ${props.theme.colors.white.base};
      margin-right: ${props.theme.spacing.base};
      padding: ${props.theme.spacing.small.s8} ${props.theme.spacing.base};
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.base};
      border: 1px solid transparent;
      cursor: pointer;

      &:hover{
        border: 1px solid ${props.theme.colors.blue.base};
        color: ${props.theme.colors.blue.base};
      }

      &.active{
        border: 1px solid ${props.theme.colors.blue.base};
        color: ${props.theme.colors.blue.base};
      }
    }
  `
);

export const RoomSelectOuterWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid ${props.theme.colors.grey.lightc3};
    border-radius: ${props.theme.misc.borderRadius.xxlarge};  
    margin-bottom: ${props.theme.spacing.large.l65};
  `
);


export const RoomTypeWrap = styled.div(
  props => `
    width: 42rem;
    display: flex;
    border-right: 1px solid ${props.theme.colors.grey.lightba};
  `
);

export const RoomDetailRoomType = styled.div(
  props => `
    width: 100%;
    display: flex;  
  `
);

export const RoomDivider = styled.div(
  props => `
    width:100%;
    display: flex;
    border: 0.4rem solid ${props.theme.colors.grey.lighte5};
  `
)


export const RoomTypeInnerWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: ${props.theme.spacing.large.l20};
  `
);

export const RoomTypeImgWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    position: relative;  
    background-color: ${props.theme.colors.grey.lightd8};
    border-radius: ${props.theme.misc.borderRadius.base};
    margin-bottom: ${props.theme.spacing.large.l15};
  `
);

export const RoomTypeImg = styled.img(
  props => `
    width: 37.9rem;
    height: 19.3rem;
    display: flex;
    // object-fit: contain;
    position: relative;  
    border-radius: ${props.theme.misc.borderRadius.base};
  `
);

export const FewAvailRoomTag = styled.div(
  props => `
    position: absolute;
    top: 1rem;
    left:0;
    background-image: linear-gradient(259deg, #f89d19, #f3c852);
    border-radius: 0 1.4rem 1.4rem 0;
    padding: ${props.theme.spacing.small.s3} ${props.theme.spacing.base};
  `
);

export const LastAvailRoomTag = styled.div(
  props => `
    position: absolute;
    top: 1rem;
    left:0;
    background-image: linear-gradient(78deg, #f5515f, #9f0404 100%);
    border-radius: 0 1.4rem 1.4rem 0;
    padding: ${props.theme.spacing.small.s3} ${props.theme.spacing.base};
  `
);

export const AvailRoomTagText = styled.p(
  props => `
    color: ${props.theme.colors.white.base};
    font-sie: ${props.theme.font.small.font10};
    font-weight: ${props.theme.font.fontWeight.bold};  
  `
);

export const BottomTextWrap = styled.div(
  props => `
    position: absolute;
    width: 100%;
    bottom: 0;
    background: ${props.theme.colors.black.base};
    padding: ${props.theme.spacing.small.s5};
    color: ${props.theme.colors.white.base};
    border-radius: 0 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base};
  `
);

export const BottomText = styled.div(
  props => `
    font-size: ${props.theme.font.small.font10};
  `
);

export const LeftIconWrap = styled.div(
  props => `
    position: absolute;
    top: 50%;
    left: 1rem;
    transform: translateY(-50%);
  `
);

export const RightIconWrap = styled.div(
  props => `
    position: absolute;
    top: 50%;
    right: 1rem;
    transform: translateY(-50%);
  `
);


export const RoomTypeNameText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font18};  
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
    letter-spacing: ${props.theme.font.letterSpacing.base};
  `
);

export const RoomInfoOuterWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    align-items: center;
    padding-top: ${props.theme.spacing.large.l15};
  `
);

export const RoomInfoInnerWrap = styled.div(
  props => `
    width: 50%;
    display: flex;
    flex-direction: column;
  `
);

export const RoomInfoHeadText = styled.div(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};  
    font-weight: ${props.theme.font.fontWeight.bold};
  `
);

export const RoomInfoSubText = styled.div(
  props => `
    font-size: ${props.theme.font.large.font12};
    color: ${props.theme.colors.grey.light9b};  
    padding-top: ${props.theme.spacing.small.s1};
  `
);

export const RoomInfoMoreText = styled.a(
  props => `
    font-size: ${props.theme.font.large.font12};
    color: ${props.theme.colors.blue.base};  
    font-weight: ${props.theme.font.fontWeight.black};
    text-transform: ${props.theme.font.textTransform.upper};
    cursor: pointer;
    &:hover{
        color: ${props.theme.colors.blue.base};  
    }
  `
);

export const RatePlanInnerWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    flex-direction: column;
  `
);

export const RateOptionWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    padding: ${props.theme.spacing.large.l20};
    flex-direction: column;
  `
);

export const RateOptionTagWrap = styled.span(
  props =>   `
    width: 100%;
    display: flex;
    align-items: center;
  `
);

export const RateOptionTagText = styled.p(
  props => `
    display: flex;
    justify-content: flex-start;
    background-color: ${props.theme.colors.grey.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    padding: ${props.theme.spacing.small.s4} ${props.theme.spacing.small.s6};  
    font-size: ${props.theme.font.small.font10};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.bold};  
  `
);

export const RecommendedTag = styled.p(
  props => `
    display: flex;
    justify-content: flex-start;
    background-image: linear-gradient(259deg, #3a7bd5, #00d2ff);
    border-radius: ${props.theme.misc.borderRadius.xxlarge};
    padding: ${props.theme.spacing.small.s3} ${props.theme.spacing.small.s8};
    font-size: ${props.theme.font.small.font10};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    margin-left: ${props.theme.spacing.small.s5};
  `
);

export const RateOptionInclusionList = styled.ul(
  props => `
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-top: ${props.theme.spacing.base};
    list-style-type: disc;
    padding-left: ${props.theme.spacing.large.l20};

    li{
      width: 100%;
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.grey.base};
      padding-bottom: ${props.theme.spacing.small.s8};

      &.nonRefund{
        color: ${props.theme.colors.red.base};
      }
    a{
        font-size: ${props.theme.font.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        margin-left: ${props.theme.spacing.small.s5};
        color: ${props.theme.colors.blue.base};

        &:hover{
            color: ${props.theme.colors.blue.base};
        }
      }
    }
  `
);

export const FreeCancelTag= styled.div(
  props => `
    width: 100%;
    display: flex;
    align-items: flex-start;  
    padding-top: ${props.theme.spacing.large.l15};
  `
);

export const FreeCancelTagImgWrap = styled.div(
  props => `
    width:1.9rem;
    height: 2.4rem;
    display: flex;
    margin-top: ${props.theme.spacing.small.s3};
  `
);

export const CancelInfoTextWrap = styled.div(
  props => `
    width: 90%;
    display: flex;
    flex-direction: column;
    padding-left: ${props.theme.spacing.small.s5};
  `
)

export const FreeCancelText = styled.p(
  props => `
    display: inline-flex;
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.green.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    color: ${props.color ? props.color : 'inherit'}
  `
);

export const CancelPolicyText = styled.a(
  props => `
    font-size: ${props.theme.font.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    color: ${props.theme.colors.blue.base};

    &:hover{
        color: ${props.theme.colors.blue.base};
    }
  `
);


export const MoreInclusionWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    padding-top: ${props.theme.spacing.base};  
  `
);

export const MoreInclusionText = styled.a(
  props =>  `
    font-size: ${props.theme.font.large.font14};
    font-weight: ${props.theme.font.fontWeight.black};
    color: ${props.theme.colors.blue.base};
    text-transform: ${props.theme.font.textTransform.upper};
    cursor: pointer;
    &:hover{
      color: ${props.theme.colors.blue.base};
    }
  `
);

export const  RoomPriceInnerWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    flex-direction: column;
  `
);

export const PartnerRateWrap = styled.div(
  props =>`
      width: 100%;
      display: flex;
      padding: ${props.theme.spacing.small.s7} ${props.theme.spacing.base};
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
      background-image: ${props.bgColor || 'linear-gradient(75deg, #9f0469, #f5515f)'};
      position: relative;
      justify-content: space-between;
      align-items: center;
      // &:before {
      //     content: '';
      //     position: absolute;
      //     bottom: -6px;
      //     right: 20px;
      //     border-left: 5px solid transparent;
      //     border-right: 5px solid transparent;
      //     border-top: 6px solid #9f0469;
      // }
`);

export const PartnerRateText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font16};
      color: ${props.txtColor || props.theme.colors.white.base};
      font-weight: ${props.theme.font.fontWeight.black};
      letter-spacing: ${props.theme.font.letterSpacing.base};
`);

export const PriceOptionWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    padding: ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l20};
  `
);

export const RoomPriceWrap = styled.div(
  props => `
    width:60%;
    display: flex;
    flex-direction: column;
  `
);

export const OriginalPrice = styled.p(
  props =>   `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.light9b}
    font-weight: ${props.theme.font.fontWeight.bold};
    text-decoration: line-through;
  `
);

export const NewPrice = styled.p(
  props => `
    font-size: ${props.theme.font.large.font22};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.black};
  `
);

export const DisPrice = styled.p(
  props => `
    font-size: ${props.theme.font.large.font12};
    color: ${props.theme.colors.red.base};
  `
);

export const TotalGuestText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.light9b}
    letter-spacing: ${props.theme.font.letterSpacing.base};
  `
);

export const RoomSelctBtnWrap = styled.div(
  props => `
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  `
);

export const RoomSelectBtn = styled.button(
  props => `
    display: flex;
    border-radius: 3.4rem;
    box-shadow: 0 1px 7px 0 ${props.theme.colors.black.light2};
    background-image: linear-gradient(96deg, #53b2fe 1%, #065af3 129%);
    padding:${props.theme.spacing.base} ${props.theme.spacing.large.l20};
    font-size: ${props.theme.font.large.font14};
    font-weight: ${props.theme.font.fontWeight.black};
    color: ${props.theme.colors.white.base};
    text-transform: ${props.theme.font.textTransform.upper};
    outline: none;
    cursor: pointer;
    border: none;
  `
);

export const LookingText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.red.base};
    padding: ${props.theme.spacing.base};
    text-align: ${props.theme.font.textAlign.center};
  `
);

export const RoomRatePriceOuterWrap = styled.div(
  props => `
    width: 77.8rem;
    display: flex;
    flex-direction: column;
  `
);

export const RoomRatePriceInnerWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    border-bottom: 1px solid ${props.theme.colors.grey.lightba};
    flex-grow: 1;
    background-color: ${props.theme.colors.white.bgWhite};
    &:last-child{
      border-bottom: none;
    }
  `
)

export const RatePlanDetialWrap = styled.div(
  props => `
    width: 37.8rem;
    display: flex;  
    border-right: 1px solid ${props.theme.colors.grey.lightba};
  `
);

export const RoomPriceDetailWrap = styled.div(
  props => `
    width: 40rem;
    display: flex;  
    flex-direction: column;
  `
);

export const  DealTagPriceBlock = styled.div(
  props => `
    width: 100%;
    display: flex;
    background-color: ${props.theme.colors.green.bgGreen};
    padding: ${props.theme.spacing.large.l13} ${props.theme.spacing.large.l20};
    position: relative;
    &:after{
      content: "";
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid ${props.theme.colors.green.bgGreen};
      position: absolute;
      bottom: -1rem;
      left:4rem;
    }
  `
);

export const  DealAppliedTagText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base};
    .dealApplied{
        color: ${props.theme.colors.green.dark};
        font-weight: ${props.theme.font.fontWeight.black};
    }

    .dealCode{
        color: ${props.theme.colors.grey.dark};
        font-weight: ${props.theme.font.fontWeight.bold};
    }
  `
);

export const SoldOutTextWrap = styled.div(
  props => `
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l20}
  `
);

export const SoldOutHeadText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font18};
      color: ${props.theme.colors.red.base};
      font-weight: ${props.theme.font.fontWeight.black};
  `
);

export const SoldOutSubText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.grey.base};
      padding-top: ${props.theme.spacing.large.l20};

      .bold{
          font-weight: ${props.theme.font.fontWeight.black};
      }
  `
);

export const RoomFlavorColumn = styled.div(props => {
  return `
      width: 33.3%;
      border-right: 1px solid ${props.theme.colors.grey.grey15};
      padding: ${props.theme.spacing.large.l20};
      flex-grow: 1;
      &:last-child {
        border-right: none;
      }
  `;
});

export const RecommendedLabelWrapper = styled(Column)(
  props => `
  background-image: linear-gradient(281deg, #ff6d38, #ff3a5c);
  padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.base} ${props.theme.spacing.small.s5} ${props.theme.spacing.base};
  position: relative;
  border-radius: ${props.theme.misc.borderRadius.small};
  width:11rem;
`,
);

export const RecommendedLabelPrependStyles = styled.span(
  props => `
  &::after{
    display: flex;
    content: '';
    border-top: 1.2rem solid transparent;
    border-bottom: 1.2rem solid transparent;
    position: absolute;
    border-left: 0.8rem solid white;
    left: 0px;
    top: 0px;
  }
`,
);

export const RecommendedTextStyled = styled.span(
  props => `
  font-size: ${props.theme.font.base};
  color: white;
  font-weight: bold;
  padding-left: ${props.theme.spacing.small.s5};
`,
);

export const CancellationPolicyList = styled.ul(
  props => `
  padding: ${props.theme.spacing.large.l20};
  border-top: 2px solid ${props.theme.colors.goBrand.bgBlue}
  list-style-type: none;
`,
);

export const CancellationPolicyListItem = styled.li(
  props => `
  padding: 0 0 ${props.theme.spacing.large.l15} 0;
  list-style-type:none;
`,
);

export const CancellationPolicyListLoaderSmallItem = styled.li(
  props => `
  padding: 0 0 ${props.theme.spacing.large.l15} 0;
  list-style-type:none;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  width: 50rem;
  margin-bottom :${props.theme.spacing.large.l20};
`,
);

export const CancellationPolicyListLoaderLargeItem = styled.li(
  props => `
  padding: 0 0 ${props.theme.spacing.large.l15} 0;
  list-style-type:none;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  width: 60rem;
  margin-bottom :${props.theme.spacing.large.l20};
`,
);

export const CancellationItemText = styled.span(
  props => `
  font-size: ${props.theme.font.large.font16};
  padding: 0 0 0 ${props.theme.spacing.base};
  position: relative;
  top: -3px;
`,
);

export const CancellationPolicyLoaderContainer = styled.div(
  props => `
  padding: ${props.theme.spacing.large.l15};
`,
);

export const CancellationPolicyErrorText = styled.span(
  props => `
    color: ${props.theme.colors.red.base};
  `,
);

export const YouGetPriceText = styled.p`
  color: #fff;
  font-size: 1.3rem;
  background-color: #249995;
  border-radius: 3px;
  padding: 1px 5px 1px 5px;
  margin:3px 0;
  display: flex;
  align-self: flex-start;
`;

export const BoldText = styled.span`
  font-weight: 900;
`;
